import { culture } from '../../utils/intl';

const API_URL_BASE = '/api/portfolios';
const HEADERS_JSON = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
};

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong wile fetching');
	});

const getAll = async () => {
	const result = await handleFetch(API_URL_BASE);
	const { portfolioMetaData: portfolios } = result;

	return portfolios;
};

const get = async (portfolioId) => {
	// IE11 seems to cache the URL and response hard, adding cache busting to prevent this
	const cb = new Date().getTime();

	const portfolio = await handleFetch(`${API_URL_BASE}/${portfolioId}/${culture}?cb=${cb}`);

	return portfolio;
};

/* `body` should be JSON */
const add = body => handleFetch(`${API_URL_BASE}/update`, { method: 'POST', body, headers: HEADERS_JSON }, false);
const update = body => handleFetch(`${API_URL_BASE}/update`, { method: 'PUT', body, headers: HEADERS_JSON }, false);
const updateOrder = (portfolioId, body) => handleFetch(`${API_URL_BASE}/update-order/${portfolioId}`, { method: 'POST', body }, false);
const remove = (portfolioId, itemId) => handleFetch(`${API_URL_BASE}/delete/${portfolioId}/${itemId}`, { method: 'DELETE' }, false);

export {
	getAll,
	get,
	update,
	updateOrder,
	add,
	remove,
};
